export default (state = {}, action = {}) => {
  switch (action.type) {
    case "DRIVER_LIST":
      return { ...state, ...action.payload };
    case "GET_SINGLE_DRIVER":
      return { ...state, singleDriver: action.driver, showSingleDriver: true };
    case "CHANGE_SINGLE_DRIVER":
      return { ...state, singleDriver: {}, ...action.payload };
    case "MECHANIC_LIST":
      return { ...state, ...action.payload };
    case "GET_SINGLE_MECHANIC":
      return {
        ...state,
        singleMechanic: action.mechanic,
        showSingleMechanic: true
      };
    case "CHANGE_SINGLE_MECHANIC":
      return { ...state, singleMechanic: {}, ...action.payload };
    default:
      return state;
  }
};
